import Leave from "./Leave";
export default Leave;